import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OrderTypeForm from '../../../components/masters/orderType/OrderTypeForm';
import OrderTypeTable from '../../../components/masters/orderType/OrderTypeTable';
import { fetchOrderTypes, addOrderType, updateOrderType, deleteOrderType, setOrderTypeEdit, clearOrderTypeEdit } from '../../../redux/actions/masters/orderType/orderTypeActions';
import { fetchCompanies } from '../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .order-type-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .order-type-form, .order-type-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const OrderTypePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingOrderType, formSuccess, formError } = useSelector(state => state.orderType || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchOrderTypes());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearOrderTypeEdit());
  };

  const handleSubmit = async (form) => {
    if (editingOrderType && editingOrderType.order_type_id) {
      await dispatch(updateOrderType(editingOrderType.order_type_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addOrderType(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (orderType) => {
    dispatch(setOrderTypeEdit(orderType));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteOrderType(id));
  };

  const handleCancel = () => {
    dispatch(clearOrderTypeEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      ot => ot.order_type_code === code && (!excludeId || ot.order_type_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="order-type-flex">
        <div style={tableContainer} className="order-type-table">
          <OrderTypeTable
            onNew={handleFormReset}
            orderTypes={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="order-type-form">
          <OrderTypeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingOrderType={editingOrderType}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderTypePage; 